<template>
  <div>
    <div v-if='recommendations.length' class="bg-blue-400 h-12 m-2 rounded flex">
      <div class="rounded mr-2 bg-blue-300">
        <img class="float-left w-10 h-10 m-1" src='/img/PBC_logo.svg' />
      </div>
      <h1 class="text-lg text-white align-center my-auto font-semibold tracking-loose">Robot Recommends...</h1>
    </div>

    <link-recommendations :recommendations='shortenedRecommendations' @select='addRecommendation' />
    <div v-if='recommendations.length > shortenedRecommendations.length' class="text-center">
      <a class="cursor-pointer text-sm underline text-blue-400" @click='limit += 10'>More...</a>
    </div>
  </div>

</template>
<script>
import PlusCircle from '@icons/PlusCircle.vue';
import Play from '@icons/Play.vue';
import Recommender from '@edit/tree/recommender.js';
import LinkRecommendations from '@/ui/molecules/LinkRecommendations.vue';
export default {
  props: {
    gamedata: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    component: {
      type: Object,
      required: true
    },
    transform: {
      type: Object,
      required: true
    },
    short:{
      type:Boolean,
      default:false
    }
  },
  data() {
    const recommender = new Recommender(this.partutil, this.gamedata);
    const recommendations = [];
    const components = [];
    return {
      recommendations,
      recommender,
      components,
      limit: this.short ? 2 : 5,
      justAdded: false
    }
  },
  components: {
    LinkRecommendations,
  },
  methods: {
    add() {
      this.$emit('add', {component:this.component});
    },
    addRecommendation(link) {
      this.$emit('select', link);
    },
    preview() {
      this.$emit('preview');
    }
  },
  watch:{
    component: {
      handler() {
        const {components,links} = this.partutil.findComponentsAndLinksFrom(this.component);
        this.components = components;
      },
      immediate: true
    },
    'partutil.from.components.length':{
      handler() {
        this.recommendations = this.recommender.getLinkRecommendations(this.transform, this.component);
        const {components,links} = this.partutil.findComponentsAndLinksFrom(this.component);
        this.components = components;
      },
      immediate:true
    },
    'partutil.from.links.length'() {
        this.recommendations = this.recommender.getLinkRecommendations(this.transform, this.component);
        const {components,links} = this.partutil.findComponentsAndLinksFrom(this.component);
        this.components = components;
    },
  },
  computed:{
    shortenedRecommendations() {
      return this.recommendations.slice(0, this.limit);
    }
  }
}
</script>
